module.exports = __webpack_public_path__ + "static/loading.975ac407.gif";